import React from "react";

const Loader = ({ loading }) => {
  if (!loading) return null; // Don't show the loader if it's not loading

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-primary-50 bg-opacity-50 z-50">
      <div className="health-loader">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>{" "}
    </div>
  );
};

export default Loader;
